export default __webpack_public_path__ + "static/media/icon_tips.d53f215d.svg";